import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppStore } from '../../../../../store/store';
import { AgregarElementoModal } from '../../../../modals/AgregarElementoModal';
import { AgregarEmpresaForm } from '../AgregarEmpresaForm';
import { EditarElementoModal } from '../../../../modals/EditarElementoModal';
import { EditarEmpresaForm } from '../EditarEmpresaForm';
import { obtenerEmpresas } from '../../../../../actions/empresas/empresas.actions';
import { empresa } from '../../../../../models/empresas/empresas.models';
import { guardarEmpresas } from '../../../../../reducer/empresasReducer/empresas.reducer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';

export type EmpresasScreenProps = {
	// types...
}

const EmpresasScreen: React.FC<EmpresasScreenProps> = ({ }) => {

	const empresas = useSelector((store: AppStore) => store?.empresas?.empresas || [] );
	const [ openModalEdit, setOpenModalEdit ] = React.useState(false);
	const [ openModalCreate, setOpenModalCreate ] = React.useState(false);
	const [ empresaSeleccionada, setEmpresaSeleccionada ] = React.useState<empresa>({} as empresa);
	const dispatch = useDispatch();
	async function obtenerEmpresasAsync() {
		try {
			const resp = await obtenerEmpresas();
			let listaEmpresas: empresa[] = resp.data;
			dispatch(guardarEmpresas(listaEmpresas))
		} catch {
			console.error()
		}
	}

	useEffect(() => {
		obtenerEmpresasAsync()
	}, [])

	return (
		<div className='flex flex-col gap-4 p-5 bg-white w-full border shadow-xl rounded-xl h-[85%] overflow-y-hidden'>
			{/* title */}
			<div>
				<div className='flex flex-row items-center align-middle gap-2 justify-between pl-2 pr-2'>
					<p className='font-medium lg:text-2xl md:text-lg text-base text-DegradatedText'>
						Empresas.
					</p>
					<AgregarElementoModal 
						title='Agregar empresa' 
						titleButton='Agregar empresa'
						onSwitchOpen={(value)=>{ setOpenModalCreate(value) }} 
						open={openModalCreate}
					>
						<AgregarEmpresaForm
							onClose={() => {
								console.log("cerrando y recargando")
								setOpenModalCreate(false);
								obtenerEmpresasAsync().finally(() => {})
							}}
						 />
					</AgregarElementoModal>
				</div>
			</div>
			{/* content */}
			<div className='flex gap-2 overflow-y-auto'>
				<div className={`max-h-full overflow-auto m-2 pt-2 w-full border`}>
					<table className='table table-zebra border-DarkBlue table-md table-pin-rows table-pin-cols bg-white text-center'>
						<thead>
							<tr className='text-black'>
								<th>ID</th>
								<th>Razón social</th>
								<th>Acciones</th>
							</tr>
						</thead>
						<tbody>
							{
								empresas.length > 0 && empresas.map(
									(empresa, index) => (
										<tr key={`${index}-${empresa.idEmpresa}`}>
											<td>
												{empresa.idEmpresa}
											</td>
											<td>
												{empresa.razonSocialEmpresa}
											</td>
											<td className='flex flex-row gap-4 items-center justify-center align-middle'>
												<button className='flex flex-row gap-2 items-center btn btn-sm' onClick={()=>{
													setEmpresaSeleccionada(empresa);
													setOpenModalEdit(true);
												}} >
													<FontAwesomeIcon className='' icon={faPlusCircle} />
													<h1 className='font-semibold lg:block hidden'>
														Editar
													</h1>
												</button>
											</td>
										</tr>
									)
								)
							}
						</tbody>
					</table>
					{
						empresas.length === 0 && (
							<div className='flex justify-center pt-5 pb-5'>
								<h1 className='font-semibold text-xl'> Sin información</h1>
							</div>
						)
					}
				</div>
			</div>
			<EditarElementoModal 
				title='Editar empresa' 
				titleButton='Editar' 
				onSwitchOpen={(value)=>{ setOpenModalEdit(value) }} 
				open={openModalEdit}
			>
				<EditarEmpresaForm 
					onClose={() => {
						setOpenModalEdit(false);
						obtenerEmpresasAsync().finally(() => {})
					}}
					idEmpresa={empresaSeleccionada.idEmpresa} 
					datosEmpresa={{
						razonSocialEmpresa: empresaSeleccionada.razonSocialEmpresa,
						logoEmpresa: "sinCambios",
						logoEmpresaBase64: "sinCambios",
						imagenPortadaEmpresa: "sinCambios",
						imagenPortadaEmpresaBase64: "sinCambios",
						colorPrincipal: empresaSeleccionada.colorPrincipal,
						colorSecundario: empresaSeleccionada.colorSecundario,
						colorTexto: empresaSeleccionada.colorTexto,
						telefonoOrigen: empresaSeleccionada.telefonoOrigen,
						appID: empresaSeleccionada.appID,
						privateKey: empresaSeleccionada.privateKey,
						dominio: empresaSeleccionada.dominio,
						template: empresaSeleccionada.template,
						idDominio: empresaSeleccionada.idDominio || 0
					}} 
				/>
			</EditarElementoModal>
		</div>
		
	);
};

export default EmpresasScreen;
